import HTTPService from '@/api/http/HTTPService'

import StaticInterface from './StaticInterface'

export default {
  getAll: (siteSlug: string) => HTTPService.get(`site/${siteSlug}/static-page`),
  update: (siteSlug: string, payload: StaticInterface) => HTTPService.post(`site/${siteSlug}/static-page`, payload),
}
